import { defineRouting } from 'next-intl/routing';
import { createNavigation } from 'next-intl/navigation';
import { locales, defaultLocale } from './config';

export const routing = defineRouting({
  locales,
  defaultLocale,
  localePrefix: 'as-needed', // Default locale (en) uses clean URLs; others prefixed
  // MUST stay false. next-intl's cookie sync wrote NEXT_LOCALE on prefetches
  // and flipped the homepage language for English visitors (2026-09-01); the
  // explicit preference is read by src/middleware.ts instead — see the
  // "LOCALE PREFERENCE COOKIE" section there before touching this.
  localeCookie: false,
});

// Create locale-aware navigation helpers
export const { Link, redirect, usePathname, useRouter, getPathname } = createNavigation(routing);
